module.exports = __webpack_public_path__ + "static/media/incorrect-reference-logo.04369981.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/incorrect-reference-logo.png
// module id = 1314
// module chunks = 0